<template>
 <div class="home" :style="{'margin-top':top_margin+45 + 'px'}">
  <!-- <van-nav-bar :border='false' :style="{'margin-top':top_margin + 'px'}" style="height: 50px;">
    <img slot="left" class="homemem" :src="img.lexus" @click="goMy(0)">
    <van-row slot="title" gutter="20" type="flex" justify="center" style="height: 50px;">
      <van-col span="10" data-code="1" @click="checklum" :class="type==1?fontfocus:'font-color'"><div class="f-14 f-w">推荐</div><div class="f-12 f-w">Hot</div></van-col>
      <van-col span="10" data-code="2" @click="checklum" :class="type==2?fontfocus:'font-color'"><div class="f-14 f-w">话题</div><div class="f-12 f-w">Topics</div></van-col>
    </van-row>
    <img slot="right" @click="PopupShow" class="homewrite" :src="img.writeblack">
  </van-nav-bar> -->
  <van-nav-bar :border='false' ref="container" :style="{'margin-top':top_margin + 'px'}" >
    <img slot="left" class="homemem" :src="img.lexus" @click="goMy(0)">
    <img slot="title" class="navbartitle" :src="img.perfect">
    <img slot="right" @click="PopupShow" class="homewrite" :src="img.writeblack">
  </van-nav-bar>
  <div class="top_box" ref="topbox" :style="{'top':topHeight + 'px'}">
    <img class="title_pic" :src="type=='1'?img.hot_have:img.hot" data-code="1" @click="checklum">
    <img class="title_pic" :src="type=='0'?img.user_have:img.user" data-code="0" @click="checklum">
    <img class="title_pic" :src="type=='2'?img.topic_have:img.topic" data-code="2" @click="checklum">
  </div>
  <van-pull-refresh class="bbsrem" v-model="isLoading" @refresh="onRefresh" :style="{'margin-top':topHeightd + 'px'}">
    <div v-if="type==1">
      <van-notice-bar color="#000" background="#fff" style="padding:0 0 !important;height: 30px;" :scrollable='true' v-if="scrollList.length>0">
        <span v-for="item in scrollList" :key="'scroll_'+item.id" class="scroll_title" :data-url="item.jump_id" :data-code="item.id" @click="goNotice">{{item.title}}［查看］</span> 
      </van-notice-bar>
      <van-swipe
      :autoplay="3000"
      :duration="1000"
      indicator-color="white"
      >
      <van-swipe-item v-for="item in sliders" :key="'swipe_'+item.id">
        <img class="swipe-img" v-lazy="item.pic_url" :id="item.id" :name="item.id" @click="picurl(item.url)">
      </van-swipe-item>
    </van-swipe>
    <div class="addtopicbox">
      <button class="indextopicbox" v-for="item in IndextopTopiclist" :key="'listac_' + item.id" @click="binTopic(item.id)">#{{item.name}}#</button>
      <div class="changeTopic" @click="changeTopiclist">
        <img class="changeimg" :src="img.change">换一批话题
      </div>

    </div>
  </div>
  <div v-if="type==1">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
    </div>
    <div class="box" v-for="item in activelist" :key="'listtop_' + item.id">
      <div class="list-box">
        <van-row type="flex" justify="space-between">
          <van-col span="3">
            <img class="listhand" :src="img.lexus">
          </van-col>
          <van-col class="ml-10" span="16">
            <div class="activename">
              凌志范儿
            </div>
          </van-col>
          <van-col class="bintright" @click="ActionShow(item.id)" span="5">
            <van-tag class="active" plain size="large">活动<van-icon class="ml-5" name="arrow-down" /></van-tag>
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2" @click="ActiveApply(item.id,item.type.id)">{{item.title}} </div>
        <div class="f-15 ellipsis-4 listcontent" @click="ActiveApply(item.id,item.type.id)">{{item.name}}</div>
      </div>
      <div class="pic-box" @click="ActiveApply(item.id,item.type.id)">
        <img class="pic_thumb" v-if="item.pic" v-lazy="item.pic">
      </div>
      <div class="list-box">
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <span class="binbox">
              <img class="binpic" v-lazy="img.collect">
              <span class="statenum" v-if="item.likes>0">{{item.likes}}</span>
            </span>
            <span class="binbox" @click="ActiveApply(item.id,item.type.id)">
              <img class="binpic" :src="img.comment">
              <span class="statenum" v-if="item.comments&&item.comments.length>0">{{item.comments.length}}</span>
            </span>
            <span class="binbox" hidden="true">
              <img class="binpic" :src="img.inrelay">
              <span class="statenum"></span>
            </span>
          </van-col>
          <van-col class="bintright" span="6" @click="outrelay(item.title,item.post_id,item.id,item.content,item.share_image)">
            <img class="binpic" :src="img.outrelay">
          </van-col>
        </van-row>
        <van-tag v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4" @click="binTopic(tag.id)">#{{tag.name}}#</van-tag>
        <div class="binbox">
          <!-- <img class="location" :src="img.location"> -->
          <!-- <span class="sourtime">{{item.time_format}}</span> -->
        </div>
        <van-row gutter="15" class="mt-20" v-for="(item,index) in item.comments" :key="'lista_' + index" v-show="index<3?true:false">
          <van-col span="2" class="handpeop">
            <img class="commhand" @click="goMy(1,item.user.id)" :src="item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https' ?item.user.headimg_url :img.avatar">
          </van-col>
          <van-col span="21" class="f-12 ellipsis-3 commember ml-10">
            <span class="f-w c-member">{{item.user.user_name}}：</span>{{item.content}}
          </van-col>
        </van-row>
        <van-row class="mt-20">
          <van-col span="2" class="handpeop">
            <img class="commhand opactypic" :src="user && user.avatar ? user.avatar : img.avatar">
          </van-col>
          <!-- @click="ActiveApply(item.id,item.type.id)" -->
          <van-col span="21" class="f-12 ellipsis-2 addcommont ml-10">
            <van-row>
              <van-col span="19">
                <van-field :left-icon="img.writecomm" v-model="value" @focus="addCommont(0,item.id)" :focus="inputfocus" placeholder="添加评论..." ref="inputTag" />
              </van-col>
              <van-col span="5" v-if="item.id==inputnum">
                <van-button color="#3a3a3a" size="small" @click="post()">发表</van-button>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="box" v-for="item in listtop" :key="'list_' + item.id">
      <div class="list-box" v-if="item.user">
        <van-row type="flex" justify="space-between">
          <van-col span="3">
            <div class="listhand_box">
              <img class="listhand" @click="goMy(1,item.user.id)" :src="item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https' ?item.user.headimg_url :img.avatar">
              <img class="listhand_border" :src="img.border_pic" v-if="item.user.auth.is_audit==1">
            </div>
          </van-col>
          <van-col class="ml-10 discenter" span="16" @click="goMy(1,item.user.id)">
            <div v-if="item.user.cars">
              <div class="membername">
                {{item.user.user_name}}
              </div>
              <div v-if="item.user.cars.id" class="sourtime">
                <img class="member_car" :src="img.member_car">
                {{item.user.cars.title}} 车主
              </div>
              <!-- <div v-elif="item.user.intro" class="sourtime">
                {{item.user.intro}}
              </div> -->
            </div>
            <div v-else class="activename">
              {{item.user.user_name}}
            </div>
          </van-col>
          <van-col class="bintright" span="5">
            <van-button class="follow settop" type="default" size="small"> 置  顶 </van-button>
          </van-col>
        </van-row>
        <div class="f-14 ellipsis-4 mt-10" style="line-height: 2;" v-if="item.remark" @click="binTopic(item.id)">{{item.remark}}</div>
        <!-- <div class="f-15 ellipsis-4 listcontent" @click="BbsShow(item.id,item.url)">{{item.content}}</div> -->
      </div>
      <div class="topic">
        <div class="topichei" @click="binTopic(item.id)">
          <img  class="topicpic" :src="item.pic_url">
          <div class="picount">
            <div class="f-14" v-if="item.keyword">{{item.keyword}}</div>
            <div class="f-14" v-else>话题</div>
            <van-divider />
            <div class="f-16 mt-10 f-w">#{{item.name}}#</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box" v-for="(item,index) in list" :key="'list_' + item.id">
      <div class="box" v-if="item.topic_info.id">
        <div class="list-box" v-if="item.user">
          <van-row type="flex" justify="space-between">
            <van-col span="3">
              <div class="listhand_box">
                <img class="listhand" @click="goMy(1,item.topic_info.user.id)" :src="item.topic_info.user.headimg_url&&item.topic_info.user.headimg_url.substring(0,5)=='https' ?item.topic_info.user.headimg_url :img.avatar">
                <img class="listhand_border" :src="img.border_pic" v-if="item.topic_info.user.auth.is_audit==1">
              </div>
            </van-col>
            <van-col class="ml-10 discenter" span="16" @click="goMy(1,item.topic_info.user.id)">
              <div v-if="item.topic_info.user.cars">
                <div class="membername">
                  {{item.topic_info.user.user_name}}
                </div>
                <div v-if="item.topic_info.user.cars" class="sourtime">
                  <img class="member_car" :src="img.member_car">
                  {{item.topic_info.user.cars.title}} 车主
                </div>
                <!-- <div v-elif="item.topic_info.user.intro" class="sourtime">
                  {{item.topic_info.user.intro}}
                </div> -->
              </div>
              <div v-else class="activename">
                {{item.topic_info.user.user_name}}
              </div>
            </van-col>
            <van-col class="bintright" span="5">
              <van-button class="follow" type="default" size="small">话 题</van-button>
            </van-col>
          </van-row>
          <div class="listitle ellipsis-2" v-if="item.remark" @click="binTopic(item.topic_info.id)">{{item.topic_info.remark}}</div>
          <!-- <div class="f-15 ellipsis-4 listcontent" @click="BbsShow(item.id,item.url)">{{item.content}}</div> -->
        </div>
        <div class="topic">
          <div class="topichei" @click="binTopic(item.topic_info.id)">
            <img  class="topicpic" :src="item.topic_info.pic_url">
            <div class="picount">
              <div class="f-14" v-if="item.keyword">{{item.keyword}}</div>
              <div class="f-14" v-else>话题</div>
              <van-divider />
              <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="list-box" v-if="item.user">
         <!-- justify="space-between" -->
         <van-row type="flex">
          <van-col span="3">
           <div class="listhand_box">
            <img class="listhand" @click="goMy(1,item.user.id)" :src="item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https' ?item.user.headimg_url :img.avatar">
            <img class="listhand_border" :src="img.border_pic" v-if="item.user.auth.is_audit==1">
          </div>
          
        </van-col>
        <van-col class="ml-10 discenter" span="16" @click="goMy(1,item.user.id)">
          <div v-if="item.user.cars">
            <div class="membername">
              {{item.user.user_name}}
            </div>
            <div v-if="item.user.cars.id" class="sourtime">
              <img class="member_car" :src="img.member_car">
              {{item.user.cars.title}} 车主
            </div>
              <!-- <div v-elif="item.user.intro" class="sourtime">
                {{item.user.intro}}
              </div> -->
            </div>
            <div v-else class="activename">
              {{item.user.user_name}}
            </div>
          </van-col>
          <van-col class="bintright" span="5">
            <div v-if="user">
              <van-button class="follow" v-if="item.user.is_follow==0&&item.user.id!=user.id" icon="plus" color="#3a3a3a" size="small"  @click="follow(index)" :data-code="item.user.id">关 注</van-button>
              <van-button class="followd" v-if="item.user.is_follow==1&&item.user.id!=user.id" size="small"  @click="follow(index)" :data-code="item.user.id" style="letter-spacing:1px;">已关注</van-button>
            </div>
            <div v-else>
              <van-button class="follow" v-if="item.user.is_follow==0" icon="plus" color="#3a3a3a" size="small"  @click="follow(index)" :data-code="item.user.id">关 注</van-button>
            </div>
          </van-col>
        </van-row>
        <div class="listitle ellipsis-2" @click="BbsShow(item.id,item.url,item.post_id)">{{item.title}}</div>
        <div class="f-14 ellipsis-4 listcontent" @click="BbsShow(item.id,item.url,item.post_id)">{{item.content}}</div>
      </div>
      <div class="pic-box" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.cover&&item.image.length==0">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.image.length==1">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box" @click="showPic(index)" v-if="item.image.length>1">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <div class="piclength">{{item.cover?item.image.length+1:item.image.length}}P</div>
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box videobox" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.user&&item.video">
        <img class="pic_thumb" v-lazy="img.default">
        <img class="videos" :src="img.plays">
        <!-- <iframe
        style="z-index:1;"
        :src="item.video"
        allowfullscreen=""
        frameborder="0"
        height="270"
        width="100%"
        >
      </iframe> -->
    </div>
    <div class="list-box list-comm" v-if="item.user">
      <van-row type="flex" justify="space-between">
        <van-col span="18">
          <span class="binbox">
            <!-- <img class="binpic" :src="img.collect"> -->
            <img @click="setPraise(index)" class="binpic" :src="item.is_praise==1 ? img.collect_have : img.collect">
            <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
          </span>
          <span class="binbox" @click="BbsShow(item.id,item.url,item.post_id)">
            <img class="binpic" :src="img.comment">
            <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
          </span>
          <span class="binbox" hidden="true">
            <img class="binpic" :src="img.inrelay">
            <span class="statenum"></span>
          </span>
        </van-col>
        <!-- @click="outrelay(item.title,item.content,'/lexus/bbs/'+item.id,item.image[0])" -->
        <van-col class="bintright" span="6" @click="outrelay(item.title,item.post_id,item.id,item.content,item.share_image)">
          <img class="binpic" :src="img.outrelay">
        </van-col>
      </van-row>
      <van-tag v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4" @click="binTopic(tag.id)">#{{tag.name}}#</van-tag>
      <!-- <van-tag class="ml-16" color="#F3F9FF" text-color="#728FC4">#梦想家#</van-tag> -->
      <!-- <div class="binbox">
        <img class="location" :src="img.location">
        <span class="sourtime">{{item.time_format}}</span>
      </div> -->
      <van-row class="mt-15 comm-discenter" v-for="(comm,index) in item.comments" :key="'comlista_' + index" v-show="index<3?true:false">
        <van-col span="2" class="handpeop">
          <img class="commhand" @click="goMy(1,comm.user.id)" :src="comm.user &&comm.user.headimg_url&&comm.user.headimg_url.substring(0,5)=='https' ? comm.user.headimg_url :img.avatar">
        </van-col>
        <van-col @click="BbsShow(item.id,item.url,item.post_id)" span="21" class="f-12 ellipsis-3 commember ml-10">
          <span class="f-w c-member">{{comm.user.user_name}}</span>：{{comm.content}}
        </van-col>
      </van-row>
      <van-row class="mt-15">
        <van-col span="2" class="handpeop">
          <img class="commhand opactypic" :src="user && user.avatar ? user.avatar : img.avatar">
        </van-col>
        <!-- @click="BbsShow(item.id)" -->
        <van-col span="22" class="f-12 ellipsis-2 addcommont">
          <van-row type="flex" justify="space-between">
            <van-col class="ml-10" span="18">
              <van-field :left-icon="img.writecomm" v-model="value" @focus="addCommont(1,item.id)" :focus="inputfocus" placeholder="添加评论..." ref="inputTag" />
            </van-col>
            <van-col span="5" class="text-r" v-if="item.id==inputnum">
              <van-button color="#3a3a3a" size="small" @click="post()">发表</van-button>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <div class="allTopicBox" v-if="index==2">
      <div v-for="item in AllTopiclist" :key="'alllisty_' + item.id" class="alltopic_img" :style="'background-image:url('+item.pic_url+')'">
        <div class="alltopic_namebox" @click="binTopic(item.id)">
          <div class="alltopic_name">
           #{{item.name}}#
         </div>
       </div>
     </div>
   </div>
   <div class="dvapprove" v-if="index==0">
    <div v-for="(item,index) in listnd" :key="'listnd' + item.id">
     <div class="swipe-box text-c">
      <span class="border_box" @click="goMy(1,item.id)">
        <img class="focuspic" :src="item.headimg_url&&item.headimg_url.substring(0,5)=='https' ?item.headimg_url :img.avatar">
        <img class="border_pic" v-if="item.auth.is_audit==1" :src="img.border_pic">
      </span>
      <div class="f-14 f-w ellipsis-2" style="height: 40px;" @click="goMy(1,item.id)">{{item.user_name}}</div>
      <div class="ellipsis f-12" style="min-height:25px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
        <span v-if="item.auth.is_audit==1&&item.auth.title">
          <div class="f-12 c-intro" v-for="(itemd,indexd) in item.auth.title" :key="'appro' + indexd">
            <span v-if="indexd<2">{{itemd}}</span>
          </div>
        </span>
      </div>
      <div class="ellipsis" style="min-height:25px;margin-top: 10px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
        <span class="f-12 c-intro" v-if="item.cars">{{item.cars.title}} 车主</span>
      </div>
      <div class="f-12 c-gray" v-if="item.intro">{{item.intro}} </div>
      <van-button class="follow" @click="followd(index)" :data-code="item.id" icon="plus" color="#5F5B6B" size="small" v-if="item.is_user_follow==0">关 注</van-button>
      <van-button class="followd"  size="small"  @click="followd(index)" :data-code="item.id" style="letter-spacing:1px;" v-else>已关注</van-button>
    </div>
  </div>
</div>
</div>
</div>
</van-list>
</div>
<div class="box focus" v-if="type==0">
  <div class="tuijian" v-if="update_num>0&&shou_update_num">为您推荐{{update_num}}条最新动态</div>
  <div>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
    </div>
    <div class="dvapprove">
      <div v-for="(item,index) in listnd" :key="'listnd' + item.id">
       <div class="swipe-box text-c">
        <span class="border_box" @click="goMy(1,item.id)">
          <img class="focuspic" :src="item.headimg_url&&item.headimg_url.substring(0,5)=='https' ?item.headimg_url :img.avatar">
          <img class="border_pic" v-if="item.auth.is_audit==1" :src="img.border_pic">
        </span>
        <div class="f-14 f-w ellipsis-2" style="height: 40px;" @click="goMy(1,item.id)">{{item.user_name}}</div>
        <div class="ellipsis f-12" style="min-height:25px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
          <span v-if="item.auth.is_audit==1&&item.auth.title">
            <div class="f-12 c-intro" v-for="(itemd,indexd) in item.auth.title" :key="'appro' + indexd">
              <span v-if="indexd<2">{{itemd}}</span>
            </div>
          </span>
        </div>
        <div class="ellipsis" style="min-height:25px;margin-top: 10px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
          <span class="f-12 c-intro" v-if="item.cars">{{item.cars.title}} 车主</span>
        </div>
        <div class="f-12 c-gray" v-if="item.intro">{{item.intro}} </div>
        <van-button class="follow" @click="followd(index)" :data-code="item.id" icon="plus" color="#5F5B6B" size="small" v-if="item.is_user_follow==0">关 注</van-button>
        <van-button class="followd"  size="small"  @click="followd(index)" :data-code="item.id" style="letter-spacing:1px;" v-else>已关注</van-button>
      </div>
    </div>
  </div>
    <!-- <van-swipe :loop="false" :width="190" :show-indicators="false">
      <van-swipe-item v-for="(item,index) in listnd" :key="'listnd' + item.id">
        <div class="swipe-box text-c" v-if="item.id!=user.id">
          <span class="border_box" @click="goMy(1,item.id)">
            <img class="focuspic" :src="item.headimg_url&&item.headimg_url.substring(0,5)=='https' ?item.headimg_url :img.avatar">
            <img class="border_pic" v-if="item.auth.is_audit==1" :src="img.border_pic">
          </span>
          <div class="f-14 f-w ellipsis-2" style="height: 40px;" @click="goMy(1,item.id)">{{item.user_name}}</div>
          <div class="ellipsis f-12" style="min-height:25px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
           <span v-if="item.auth.is_audit==1&&item.auth.title">
            <div class="f-12 c-intro" v-for="(itemd,indexd) in item.auth.title" :key="'appro' + indexd">
              <span v-if="indexd<2">{{itemd}}</span>
            </div>
          </span>
        </div>
        <div class="ellipsis" style="min-height:25px;margin-top: 10px;" data-code="item.id" data-name="item.user_name" @click="goMy(1,item.id)">
          <span class="f-12 c-intro" v-if="item.cars.id">{{item.cars.title}} 车主</span>
        </div>
        <div class="f-12 c-gray" v-if="item.intro">{{item.intro}} </div>
        <van-button class="follow" @click="followd(index)" :data-code="item.id" icon="plus" color="#5F5B6B" size="small" v-if="item.is_user_follow==0">关 注</van-button>
        <van-button class="followd"  size="small"  @click="followd(index)" :data-code="item.id" style="letter-spacing:1px;" v-else>已关注</van-button>
      </div>
    </van-swipe-item>
  </van-swipe> -->
  <div class="focusbbox" v-for="(item, index) in listf" :key="'list1_' + item.id">
    <div class="box" v-if="item.topic_info.id">
      <div class="list-box" v-if="item.user">
        <van-row type="flex" justify="space-between">
          <van-col span="3">
            <div class="listhand_box">
              <img class="listhand" @click="goMy(1,item.topic_info.user.id)" :src="item.topic_info.user.headimg_url&&item.topic_info.user.headimg_url.substring(0,5)=='https' ?item.topic_info.user.headimg_url :img.avatar">
              <img class="listhand_border" :src="img.border_pic" v-if="item.topic_info.user.auth.is_audit==1">
            </div>
            
          </van-col>
          <van-col class="ml-10 discenter" span="16" @click="goMy(1,item.topic_info.user.id)">
            <div v-if="item.topic_info.user.cars">
              <div class="membername">
                {{item.topic_info.user.user_name}}
              </div>
              <div v-if="item.topic_info.user.cars" class="sourtime">
                <img class="member_car" :src="img.member_car">
                {{item.topic_info.user.cars.title}} 车主
              </div>
                <!-- <div v-elif="item.topic_info.user.intro" class="sourtime">
                  {{item.topic_info.user.intro}}
                </div> -->
              </div>
              <div v-else class="activename">
                {{item.topic_info.user.user_name}}
              </div>
            </van-col>
            <van-col class="bintright" span="5">
              <van-button class="follow" type="default" size="small">话 题</van-button>
            </van-col>
          </van-row>
          <div class="listitle ellipsis-2" v-if="item.remark" @click="binTopic(item.topic_info.id)">{{item.topic_info.remark}}</div>
          <!-- <div class="f-15 ellipsis-4 listcontent" @click="BbsShow(item.id,item.url)">{{item.content}}</div> -->
        </div>
        <div class="topic">
          <div class="topichei" @click="binTopic(item.topic_info.id)">
            <img  class="topicpic" :src="item.topic_info.pic_url">
            <div class="picount">
              <div class="f-14" v-if="item.keyword">{{item.keyword}}</div>
              <div class="f-14" v-else>话题</div>
              <van-divider />
              <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="list-box">
          <van-row type="flex" justify="space-between" v-if="item.user">
            <van-col span="4">

              <div class="listhand_box">

                <img class="listhand" @click="goMy(1,item.user.id)" :src="item.user.headimg_url&&item.user.headimg_url.substring(0,5)=='https' ?item.user.headimg_url :img.avatar">
                <img class="listhand_border" :src="img.border_pic" v-if="item.user.auth.is_audit==1">
              </div>
            </van-col>
            <van-col span="15" @click="goMy(1,item.user.id)">
              <div v-if="item.user.intro" class="membername">
                {{item.user.user_name}}
              </div>
              <div v-if="item.user.intro" class="sourtime">
                {{item.user.intro}}
              </div>
              <div v-else class="activename">
                {{item.user.user_name}}
              </div>
            </van-col>
            <van-col class="bintright" span="5">
             <!--  <van-button class="follow" @click="follow(index)" :data-code="item.user.id" v-if="item.user.is_follow==0" icon="plus" color="#5F5B6B" size="small">关 注</van-button> -->
           </van-col>
         </van-row>
         <div class="listitle ellipsis-2" @click="BbsShow(item.id,item.url,item.post_id)">{{item.title}}</div>
         <div class="f-15 ellipsis-4 listcontent" @click="BbsShow(item.id,item.url,item.post_id)">{{item.content}}</div>
       </div>
       <div class="pic-box" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.cover&&item.image.length==0">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.image.length==1">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box" @click="showPic(index)" v-if="item.image.length>1">
        <img class="pic_thumb" v-lazy="item.cover?item.cover:item.image[0]">
        <div class="piclength">{{item.cover?item.image.length+1:item.image.length}}P</div>
        <!-- <img class="picenter" v-if="item.image.length>1" :src="img.picture"> -->
      </div>
      <div class="pic-box videobox" @click="BbsShow(item.id,item.url,item.post_id)" v-if="item.video">
        <img class="pic_thumb" v-lazy="img.default">
        <img class="videos" :src="img.plays">
      </div>
      <div class="list-box">
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <span class="binbox">
              <img @click="setPraise(index)" class="binpic" :src="item.is_praise==1 ? img.collect_have : img.collect">
              <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
            </span>
            <span class="binbox" @click="BbsShow(item.id,item.url,item.post_id)">
              <img class="binpic" :src="img.comment">
              <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
            </span>
            <span class="binbox" hidden="true">
              <img class="binpic" :src="img.inrelay">
              <span class="statenum"></span>
            </span>
          </van-col>
          <van-col class="bintright" span="6" @click="outrelay(item.title,item.post_id,item.id,item.content,item.share_image)">
            <img class="binpic" :src="img.outrelay">
          </van-col>
        </van-row>
        <van-tag v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4" @click="binTopic(tag.id)">#{{tag.name}}#</van-tag>
        <!--  <van-tag v-if="item.topics.length>0" v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4" @click="binTopic(tag.id)">#{{tag.name}}#</van-tag> -->
        <van-row gutter="15" class="mt-20" v-for="(comm,index) in item.comments" :key="'comlist_' + index" v-show="index<3?true:false">
          <van-col span="3" class="handpeop">
            <img class="commhand" @click="goMy(1,comm.user.id)" :src="comm.user &&comm.user.headimg_url ? comm.user.headimg_url :img.avatar">
          </van-col>
          <van-col span="21" class="f-12 ellipsis-3 commember" @click="BbsShow(item.id,item.url,item.post_id)">
            <span class="f-w c-member">{{comm.user.user_name}}</span>：{{comm.content}}
          </van-col>
        </van-row>
        <van-row gutter="15" class="mt-20">
          <van-col span="3" class="handpeop">
            <img class="commhand opactypic" :src="user && user.avatar ? user.avatar : img.avatar">
          </van-col>
          <van-col span="21" class="f-12 ellipsis-2 addcommont">
            <van-row>
              <van-col span="19">
                <van-field :left-icon="img.writecomm" v-model="value" @focus="addCommont(0,item.id)" :focus="inputfocus" placeholder="添加评论..." ref="inputTag" />
              </van-col>
              <van-col span="5" v-if="item.id==inputnum">
                <van-button color="#3a3a3a" size="small" @click="post()">发表</van-button>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="allTopicBox" v-if="index==1">
      <div v-for="item in AllTopiclist" :key="'alllisty_' + item.id" class="alltopic_img" :style="'background-image:url('+item.pic_url+')'">
        <div class="alltopic_namebox" @click="binTopic(item.id)">
          <div class="alltopic_name">
           #{{item.name}}#
         </div>
       </div>
     </div>
   </div>
 </div>
</van-list>
</div>
<!-- <div class="list-box" v-else>
  <div class="text-c f-12 c-gray">您还没有关注任何人哟~</div>
  <van-row class="focusrow" v-for="(item,index) in listnd" :key="'listn_' + item.id" type="flex" justify="space-between">
    <van-col span="4">
      <img class="listhand" @click="goMy(1,item.id)" :src="item.headimg_url&&item.headimg_url.substring(0,5)=='https' ?item.headimg_url :img.avatar">
    </van-col>
    <van-col span="15" @click="goMy(1,item.id)">
      <div class="membername">{{item.user_name}}</div>
      <div class="sourtime" v-if="item.intro">
       {{item.intro}}
     </div>
   </van-col>
   <van-col class="bintright" span="5">
    <van-button class="follow" @click="follownd(index)" :data-code="item.id" icon="plus" color="#5F5B6B" size="small">关 注</van-button>
  </van-col>
</van-row>
<div class="changeone">
  <van-button @click="getRecommend()">换 一 批</van-button>
</div>
</div> -->
</div>
</van-pull-refresh>
<div class="topic" v-if="type==2">
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="已加载全部"
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="this.img.loading" />
  </div>
  <div v-for="item in listT" :key="'listt_' + item.id">
    <router-link :to="{name:'LexusTopicMore',params:{en_month:item.create_en_month,month:item.create_month,yeard:item.create_year}}" v-if="item.show">
      <van-cell class="f-15 f-w topcheight" :title="item.create_year+' '+item.create_en_month+' - '+item.create_month+'月'">
        <!-- <van-icon
        slot="right-icon"
        name="ellipsis"
        style="line-height: inherit;"
        /> -->
      </van-cell>
    </router-link>
    <div class="topichei" @click="binTopic(item.id)">
      <img  class="topicpic" :src="item.pic_url">
      <div class="picount">
        <div class="f-14" v-if="item.keyword">{{item.keyword}}</div>
        <div class="f-14" v-else>话题</div>
        <van-divider />
        <div class="f-16 mt-10 f-w">#{{item.name}}#</div>
        <!-- <div class="f-12 mt-10">
          <span v-if="item.join_num>0">{{item.join_num}}人参与，</span><span v-if="item.recom_num>0">{{item.recom_num}}条内容值得看</span>
        </div> -->
      </div>
    </div>
  </div>
</van-list>
</div>

<van-popup v-model="show" @close="close()"
:style="{ top: '13%',width:'30%','text-align':'center','left':'82%','background-color':'transparent' }">
<div class="triangle"></div>
<div class="popback">
  <van-cell title="写动态" @click="goPost(1)" :icon="img.dynamic" />
 <!--  <van-cell title="图片" @click="goPost(2)" :icon="img.pictur" />
  <van-cell title="视频" @click="goPost(3)" :icon="img.video" /> -->
  <van-cell title="提问" @click="goPost(4)" :icon="img.ask" />
</div>
</van-popup>
<van-popup v-model="showTotle" @close="close()"
:style="{ top: '50%',width:'75%' }">
<div style="padding: 20px">
  <div style="font-size: 14px;text-align: center">隐私协议</div>
  <div style="font-size: 12px;margin-top: 28px;line-height: 1.7;">欢迎使用凌志范儿App! 在你使用时，需要连接数据网络或者WLAN网络，产生的流量费用请咨询当地运营商。我公司非常重视你的隐私保护和个人信息保护。在你使用凌志范儿App服务前，请认真阅读
    <a @click="gotoLzfxy">《隐私协议》</a>
  全部条款，你同意并接受全部条款后再开始使用我们的服务。</div>
  <van-row gutter="20" style="margin-top: 25px;">
    <van-col span="12"><div class="disagree" @click="disagree">不同意</div></van-col>
    <van-col span="12"><div class="agree" @click="agree">同意并继续</div></van-col>
  </van-row>
</div>
</van-popup>
<van-action-sheet
v-model="actionshow"
:actions="actions"
cancel-text="取消"
@cancel="onCancel"
@click-overlay="onCancel"
@select="onSelect"
/>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @click-overlay="onCancel" @cancel="onCancel">
  <van-divider class="divider f-13">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
  <van-image-preview
  v-model="showState"
  :images="images"
  lazyLoad
  @close="close()"
  >
</van-image-preview>
<div @touchstart="touchstart()" @click="clickstart()" class="postoverlay" v-show="overlay"></div>
<div class="totopbox" @click="toTop" v-if="scroll">
  <img class="totop" :src="img.totop">
</div>
</div>
</template>
<script>
  import content from '../../api/content';
  import common from '../../api/common';
  import active from '../../api/lexus/active';
  import list from '../../api/bbs';
  import member from '../../api/member/memberinfo';
  import { mapState } from 'vuex';
  import { Swipe, SwipeItem, List, Row, Col, Tag,Grid, GridItem,Button,Popup,Cell, CellGroup,Icon,ActionSheet,Divider,PullRefresh,Field,Overlay,NavBar,ImagePreview,NoticeBar,Sticky } from "vant";
  export default {
    data () {
      return {
        top_margin: 0,
        recommend:true,
        focus:false,
        topic:false,
        login:false,
        params: {
          cid:4,
          page: 1,
          size: 4,
          user_id: 0,
          tname:'',
          is_lexus_app:1,
          source:''
        },
        paramsf: {
          user_id:0,
          is_follow:1,
          page: 1,
          size: 20,
        },
        paramsflist: {
          cid: 4,
          page: 1,
          size: 6,
          sort: 2,
          source: '',
          user_id:''
        },
        paramst: {
          media_id: 6,
          is_home:1,
          page: 1,
          size: 6
        },
        paramsht:{
          is_top:1,
          is_home:1,
          page: 1,
          size: 1
        },
        paramshtt:{
         media_id: 6,
         is_home:1,
         page: 1,
         size: 6
       },
       paramsall:{
        media_id: 6,
        is_home:1,
        page: 1,
        size: 999
      },
      paramsa:{
        brand_id:1,
        type:0,
        page: 1,
        size: 10
      },
      paramsc:{
        hid:'',
        card_id:'',
        content:''
      },
      paramsi:{
        media_id:6,
        type:4
      },
      list: [],
      listf:[],
      listT: [],
      oldlist:[],
      activelist:[],
      listnd:[],
      listy:[],
      listtop:[],
      total: 0,
      loading: false,
      finished: false,
      sliders: [],
      type:'1',
      show:false,
      showTotle:false,
      actionshow:false,
      actions: [
      { name: '收藏' },
      ],
      font:'font-wright',
      fontfocus:'font-black',
      handback:'#fff',
      scroll:false,
      showState:false,
      images:[],
      shareshow:false,
      isLoading:false,
      inputfocus:false,
      inputnum:'',
      value:'',
      overlay:false,
      IndextopTopiclist:[],
      AllTopiclist:[],
      scrollList:[],
      user_id:0,
      update_num:0,
      shou_update_num:true,
      topHeight:'',
      topHeightd:'',
      img: {
        perfect: require('../../assets/img/lexus/perfect.png'),
        loading: require('../../assets/img/loading_lexus.gif'),
        avatar: require('../../assets/img/lexus/default.png'),
        write: require('../../assets/img/lexus/write.png'),
        writeblack: require('../../assets/img/lexus/write-black.png'),
        pic:require('../../assets/img/lexus/1.png'),
        collect: require('../../assets/img/lexus/collect.png'),
        collect_have: require('../../assets/img/lexus/collect_have.png'),
        comment: require('../../assets/img/lexus/comment.png'),
        inrelay: require('../../assets/img/lexus/inrelay.png'),
        outrelay: require('../../assets/img/lexus/outrelay.png'),
        location: require('../../assets/img/lexus/location.png'),
        writecomm:require('../../assets/img/lexus/writecomm.png'),
        dynamic:require('../../assets/img/lexus/dynamic.png'),
        pictur:require('../../assets/img/lexus/pictur.png'),
        video:require('../../assets/img/lexus/video.png'),
        ask:require('../../assets/img/lexus/ask.png'),
        lexus:require('../../assets/img/lexus/lexus.png'),
        picture:require('../../assets/img/lexus/picture.png'),
        focus:require('../../assets/img/lexus/focus.png'),
        focusout:require('../../assets/img/lexus/focusout.png'),
        friends: require('../../assets/img/lexus/friends.png'),
        wechat: require('../../assets/img/lexus/wechat.png'),
        link: require('../../assets/img/lexus/link.png'),
        poster: require('../../assets/img/lexus/poster.png'),
        totop: require('../../assets/img/lexus/totop.png'),
        plays:require('../../assets/img/lexus/plays.png'),
        default: require('../../assets/img/default_lexus.png'),
        member_car: require('../../assets/img/member_car.png'),
        hot:require('../../assets/img/lexus/hot.png'),
        hot_have:require('../../assets/img/lexus/hot_have.png'),
        user:require('../../assets/img/lexus/user.png'),
        user_have:require('../../assets/img/lexus/user_have.png'),
        topic:require('../../assets/img/lexus/topic.png'),
        topic_have:require('../../assets/img/lexus/topic_have.png'),
        change:require('../../assets/img/lexus/change.png'),
        border_pic:require('../../assets/img/lexus/border.gif'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        this.getScrollList()
      }else{
        if(this.source==6||this.source==7||this.source==8){
          this.showTotle=true
        }
      }
    })
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: false})
    this.$appService.getWinHeight(v => {
      console.log('getWinHeight=='+v.height)
      this.top_margin = 0
    })
    this.$appService.isTabbar({state: false})
    this.getSlider()
      // this.getActiveList()
      
      this.getMyInfo()
      this.getHomeTopicList()
      this.getHomeTopTopicList()
      this.getAllTopicList()
      this.weburl=process.env.VUE_APP_URL
      var params={
        user_id:this.user_id,
        source:this.source
      }
      this.getRecommend(params)
      
    },
    mounted () {
      // window.addEventListener('scroll', this.scrollToTop)
      this.topHeight = this.$refs.container.$refs.navBar.offsetHeight;
      console.log(this.$refs.container.$refs.navBar.offsetHeight)
      this.topHeightd = this.$refs.topbox.offsetHeight+this.$refs.container.$refs.navBar.offsetHeight;
    },
    methods: {
      setPraise (index) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.list[index].is_praise ? 2 : 1;
          list.setPraise({id: this.list[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].is_praise = 1
                this.list[index].praise_num += 1
              } else {
                this.list[index].is_praise = 0
                this.list[index].praise_num -= 1
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      scrollToTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop>224){
          this.font="font-black"
          this.handback='#fff'
          this.scroll=true
        }else{
          if(this.type==0){
            this.font="font-wright"
            this.handback='none'
            this.scroll=false
          }else if(this.type==2){
            this.font="font-black"
            this.handback='#fff'
            this.scroll=false
          }
          else{
            this.font="font-black"
            this.handback='#fff'
            this.scroll=false
          }
        }
      },
      toTop(){
        scrollTo(0,0);
        this.scroll=false
      },
      getSlider () {
        content.getAdvs(this.paramsi).then(res => {
          if(res.data.state == 1) {
            this.sliders = res.data.data
          }
        })
      },
      getActiveList() {
        content.getActiveList(this.paramsa).then(res => {
          if(res.data.state == 1) {
           this.activelist = res.data.data.data
         }
       })
      },
      getScrollList(){
        content.getScrollList(6).then(res => {
          if(res.data.state == 1) {
           this.scrollList = res.data.data
         }
       })
      },
      goNotice(e){
        var id=e.currentTarget.dataset.code
        var url=e.currentTarget.dataset.url
        var index=e.currentTarget.dataset.index
        var urls=url.split('?')
        var ids=urls[1]
        var idsd=ids.split('=')
        var idd=idsd[1]
        if(urls[0]=='/pages/articleinfo/articleinfo'){
          var params={
            url:this.weburl+'/lexus/bbs/'+idd+'?source='+this.source,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }else if(urls[0]=='/pages/article/article'){
          var params={
            url:this.weburl+'/lexus/article/'+idd+'/post?source='+this.source,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }else if(urls[0]=='/pages/mymessage/mymessage'){
          var params={
            url:this.weburl+'/lexus/my/message?source='+this.source+'&active='+idd,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
        var params={
          event_code: '首页推荐',
          event_id: id,
          title: '',
          value: '',
          path: '/Lexus/Home.vue',
          user_id: this.user_id,
          source: this.source,
          source_page: '首页-推荐-滚动消息'
        }
        common.BurialPoint(params).then(res => {
          if(res.data.state==1){

          }
        })
      },
      getHomeTopicList(){
        content.getTopicList(this.paramsht).then(res => {
          if(res.data.state == 1) {
           this.listtop = res.data.data.data
         }
       })
      },
      changeTopiclist(){
        if(this.paramshtt.page<this.last_page){
          this.paramshtt.page+=1
        }else{
          this.paramshtt.page=1
        }
        var params={
          event_code: '首页推荐',
          event_id: '',
          title: '',
          value: '',
          path: '/Lexus/Home.vue',
          user_id: this.user_id,
          source: this.source,
          source_page: '首页-推荐-换一批话题'
        }
        common.BurialPoint(params).then(res => {
          if(res.data.state==1){

          }
        })
        this.getHomeTopTopicList()
      },
      getHomeTopTopicList(){
        content.getTopicList(this.paramshtt).then(res => {
          if(res.data.state == 1) {
            this.last_page=res.data.data.last_page
            this.IndextopTopiclist= res.data.data.data
          }
        })
      },
      getAllTopicList(){
        content.getTopicList(this.paramsall).then(res => {
          if(res.data.state == 1) {
            this.AllTopiclist= res.data.data.data
          }
        })
      },
      PopupShow(){
        this.show=true
        this.$appService.isTabbar({state: true})
      },
      ActionShow(id){
        this.actionshow=true
        this.activeId=id
        this.$appService.isTabbar({state: true})
      },
      showImg(image){
        this.$appService.isTabbar({state: true})
        var images=[]
        images.push(image)
        this.images=images
        this.showState=true
      },
      close(){
        this.show=false
        this.showTotle=false
        this.$appService.isTabbar({state: false})
      },
      onSelect(item){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          var item=item.name
          if(item=='收藏'){
            var type=1
          }else{
            var type=2
          }
          active.Collect(this.activeId, type).then(res => {
            if(type==2){
              var list=this.activelist
              for(var i=0;i<list.length;i++){
                if(list[i].id==this.activeId){
                  list[i].likes=list[i].likes-1
                }
              }
              this.activelist=list
              this.$appService.isTabbar({state: false})
              this.actionshow=false
            }else{
              var list=this.activelist
              for(var i=0;i<list.length;i++){
                if(list[i].id==this.activeId){
                  list[i].likes=list[i].likes+1
                }
              }
              this.activelist=list
              this.$appService.isTabbar({state: false})
              this.actionshow=false
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      getContainer() {
        return document.querySelector('.homewrite');
      },
      checklum(e){
        let code=e.currentTarget.dataset.code
        this.type=e.currentTarget.dataset.code
        if(this.type==1){
          this.font="font-black"
          this.handback='#fff'
          this.scroll=false
          window.scrollTo(0, 0)
          var params={
            event_code: '首页',
            event_id: '',
            title: '',
            value: '',
            path: '/Lexus/Home.vue',
            user_id: this.user_id,
            source: this.source,
            source_page: '首页-推荐'
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){

            }
          })
        }else if(this.type==0){
          this.font="font-wright"
          this.handback='none'
          this.scroll=false
          this.paramsf.user_id = this.user ? this.user.id : 0

          // if (this.paramsf.user_id!=0) {
          //   this.login=true
          //   this.getRecommendLogin()
          // }else{
          //   this.login=false
          //   this.getRecommend()
          // }
          window.scrollTo(0, 0)
          var params={
            event_code: '首页',
            event_id: '',
            title: '',
            value: '',
            path: '/Lexus/Home.vue',
            user_id: this.user_id,
            source: this.source,
            source_page: '首页-用户'
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){

            }
          })
        }else{
          this.font="font-black"
          this.handback='#fff'
          this.scroll=false
          window.scrollTo(0, 0)
          var params={
            event_code: '首页',
            event_id: '',
            title: '',
            value: '',
            path: '/Lexus/Home.vue',
            user_id: this.user_id,
            source: this.source,
            source_page: '首页-话题'
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){

            }
          })
        }
      },
      onRefresh() {
        this.$appService.getToken(v => {
          if(v.token) {
            this.list=this.list
            this.listT=this.listT
            this.oldlist=this.oldlist
            this.$store.dispatch('param/setToken', v.token)
          }
        })
        this.isLoading = false;
        this.getMyInfo()

        // this.params.page=1
        // this.list=[]
        // this.paramst.page=1
        // this.listT=[]
        // this.oldlist=[]
        // this.loading = false
        // this.finished=false
        // if(this.params.page==1){
        //   this.onLoad()
        // }
      },
      getMyInfo(){
       var luser=JSON.parse(localStorage.getItem("user"))
       if(luser){
        var id=luser.data.id
        member.getMyInfo(id).then(res => {
          if(res.data.state==1){
            var info=res.data.data
            this.user.avatar=info.avatar
            this.user_id=info.id
            var params={
              event_code: this.type==1?'首页推荐':'首页话题',
              event_id: '',
              title: '',
              value: '',
              path: '/Lexus/Home.vue',
              user_id: info.id,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }
        })
      }else{
        var params={
          event_code: this.type==1?'首页推荐':'首页推荐',
          event_id: '',
          title: '',
          value: '',
          path: '/Lexus/Home.vue',
          user_id: '',
          source: this.source
        }
        common.BurialPoint(params).then(res => {
          if(res.data.state==1){

          }
        })
      }
    },

    getRecommend(params){
      active.getRecommend(params).then(res => {
        this.listnd=res.data.data
      })
    },
    getRecommendLogin(){
      active.getRecommendLogin(this.params).then(res => {
        this.listy.push.apply(this.listy, res.data.data)
      })
    },
    picurl(url){
      if(url){
        var params={
          url:url+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
      
    },
    ActiveApply(id,type){
      var params={
        url:'' ,
        isReturn: true 
      }
      if(type==1){
        params.url=this.weburl+'/lexus/my/activeapply/'+id+'?source='+this.source
      }else{
        params.url=this.weburl+'/lexus/my/activeinfo/'+id+'?source='+this.source
      }
      this.$appService.openWebView(params)
    },
    gotoLzfxy(){
      var params={
        url:this.weburl+'/lexus-falv?source='+this.source ,
        isReturn: true 
      }
      this.$appService.openWebView(params)
    },
    goMy(type,id){

      if(type==0){

        this.$appService.getToken(v => {
          if(v.token) {
            var params={
              url:this.weburl+'/lexus/my?source='+this.source ,
              isReturn: true 
            }
            this.$appService.openWebView(params)
            this.$store.dispatch('param/setToken', v.token)
          }else{
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
            // var params={
            //   url:this.weburl+'/lexus/my',
            //   pagetype:2,
            //   isReturn: true 
            // }
            // this.$appService.needLogin(params)
          }
        })
        
      }
      else{
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)   
      }
      
    },
    BbsShow(id,url,post_id){
      if(url){
        var params={
          url:url+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }else if(post_id){
        var params={
          url:this.weburl+'/lexus/article/'+post_id+'/post?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }else{
        var params={
          url:this.weburl+'/lexus/bbs/'+id+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
      
    },
    binTopic(id){
      var params={
        url:this.weburl+'/lexus/topicinfo/'+id+'?source='+this.source,
        isReturn: true 
      }
      this.$appService.openWebView(params)
    },
    follow(index){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.list[index].user.is_follow==1 ? 2 : 1;
        content.Follow({follow_user_id: this.list[index].user.id, type: type,media_id: 6}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.list[index].user.is_follow=1
              var id=this.list[index].user.id
              var list=this.list
              for(var i=0;i<list.length;i++){
                if(list[i].user.id==id){
                  var followi=this.list[i].user.is_follow
                  this.list[i].user.is_follow=1
                }
              }
            } else {
              this.list[index].user.is_follow=0
              var id=this.list[index].user.id
              var list=this.list
              for(var i=0;i<list.length;i++){
                if(list[i].user.id==id){
                  this.list[i].user.is_follow=0
                }
              }
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    followd(index){
     this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
     if(this.user) {
      let type = this.listnd[index].is_user_follow==1 ? 2 : 1;
      content.Follow({follow_user_id: this.listnd[index].id, type: type,media_id: 6}).then(res => {
        if(res.data.state == 1) {
          this.listy.splice(index,1)
          if(this.listnd.length<2){
            this.getRecommendLogin()
          }
        }
      })
    } else {
      this.$toast('请先登录')
      return false
    }
  },
  addCommont(type,id){

    this.$appService.getToken(v => {
      if(v.token) {
        this.$appService.isTabbar({state: true})
        member.getMemberInfo({source:this.source}).then(res => {
          if(res.data.state == 1) {
            var binding_status=res.data.data.phone_binding_status.status
            var mobile=res.data.data.mobile
            if(mobile){
              this.inputnum=id
              this.comment=type
              this.overlay=true
              if(type==0){
                this.paramsc.hid=id
                this.paramsc.card_id=''
              }else{
                this.paramsc.hid=''
                this.paramsc.card_id=id
              }
            }else{
              var params={
                url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                isReturn: true 
              }
              this.$appService.openWebView(params)
            }
          }
        })
        this.$store.dispatch('param/setToken', v.token)
      } else {
        var params={
          url:'',
          pagetype:0
        }
        this.$appService.needLogin(params)
      }
    })
  },
      touchstart(){//检测触发遮罩层，失去焦点
        this.$appService.isTabbar({state: false})
        this.inputnum=''
        this.inputfocus=false
        this.overlay=false;
        this.value=''
       // this.$refs.inputTag.blur()
     },
     post(){
      this.paramsc.content=this.value
      if(this.comment==1){
        list.Comment(this.paramsc).then(res => {
          if(res.data.state == 1) {
            this.inputnum=''
            this.inputfocus=false
            this.$toast.success('发表成功')
            this.value=''
            this.$appService.isTabbar({state: false})
            var list=this.list
            for(var i=0;i<list.length;i++){
              if(list[i].id==this.paramsc.card_id){
                var comments=list[i].comments
                var params={
                  content:this.paramsc.content,
                  user:{
                    user_name:this.user.username,
                    headimg_url:this.user.avatar
                  }
                }
                comments.unshift(params)
                list[i].comments=comments
              }
            }
          }
        })
      }else{
        active.Comment(this.paramsc).then(res => {
         if(res.data.state == 1) {
           this.inputnum=''
           this.inputfocus=false
           this.$toast.success('发表成功')
           this.value=''
           this.$appService.isTabbar({state: false})
           var activelist=this.activelist
           for(var i=0;i<activelist.length;i++){
            if(activelist[i].id==this.paramsc.hid){
              var comments=activelist[i].comments
              var params={
                content:this.paramsc.content,
                user:{
                  user_name:this.user.username,
                  headimg_url:this.user.avatar
                }
              }
              comments.unshift(params)
              activelist[i].comments=comments
            }
          }
        }
      })
      }
    },
    outrelay(title,post_id,bbs_id,content,imageUrl){
      this.$appService.isTabbar({state: true})
      this.shareshow=true
      this.sharetitle=title
      this.sharecontent=content
      var user_id=this.user?this.user.id:0
      if(post_id>0){
        this.share_id=post_id
        this.share_type=1
        this.shareurl='/pages/article/article?scene='+post_id+'-'+user_id
        var url='/lexus/article/'+post_id+'/post'
      }else{
        this.share_id=bbs_id
        this.share_type=2
        this.shareurl='/pages/articleinfo/articleinfo?scene='+bbs_id+'-'+user_id
        var url='/lexus/bbs/'+bbs_id
      }
      this.shareweburl=this.weburl+url+'?source='+this.source
      this.shareimageUrl=imageUrl?imageUrl:'https://pic.motortime.com/logo/lexus_logo.png'
    },
    // imageUrl:this.shareimageUrl,
    // imageUrl:'https://dev-pic.motortimevip.com/resize_120_120/avatar/e2/fb/e2fbf32243e6a56163e560acdd924ff4.png',
    toShare(type){
      if(type==1){
        var params={
          type:type,
          url:this.shareurl,
          imageUrl:this.shareimageUrl,
          weburl:this.shareweburl,
          wechatid:'gh_d2c493f1bc41',
          title:this.sharetitle,
          content:this.sharecontent,
        }
        this.shareshow=false
        this.$appService.shareContent(params)
        this.$appService.isTabbar({state: false})
      }else{
        this.$appService.getToken(v => {
          if(v.token) {
            if(this.share_type==1){
              var para={
                source:9,
                id:this.share_id,
                user_id:this.user.id
              }
              content.getPoster(para).then(res => {
                if(res.data.state == 1) {
                  var params={
                    type:type,
                    url:this.shareurl,
                    imageUrl:res.data.data.share_url,
                    weburl:this.shareweburl,
                    wechatid:'gh_d2c493f1bc41',
                    title:this.sharetitle,
                    content:this.sharecontent,

                  }
                  this.shareshow=false
                  this.$appService.shareContent(params)
                  this.$appService.isTabbar({state: false})
                }
              })
            }else{
              var para={
                source:9,
                cid:this.share_id,
                user_id:this.user.id
              }
              list.getPoster(para).then(res => {
                if(res.data.state == 1) {
                  var params={
                    type:type,
                    url:this.shareurl,
                    imageUrl:res.data.data.share_url,
                    weburl:this.shareweburl,
                    wechatid:'gh_d2c493f1bc41',
                    title:this.sharetitle,
                    content:this.sharecontent,
                  }
                  this.shareshow=false
                  this.$appService.shareContent(params)
                  this.$appService.isTabbar({state: false})
                }
              })
            }
          }else{
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
      }
    },
    onCancel(){
      this.$appService.isTabbar({state: false})
      this.actionshow=false
      this.show=false
    },
    goPost(type){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
          var params={
            type:type
          }
          this.show=false
          this.$appService.goPost(params)
        } else {
          this.show=false
          var params={
            pagetype:1,
            type:type
          }
          this.$appService.needLogin(params)
        }
      })
    },
    disagree(){
      this.showTotle=false
      this.$appService.closeApp()
    },
    agree(){
      this.showTotle=false
    },
    showPic(index){
      this.$appService.isTabbar({state: true})
      if(this.type==1){
        var list=this.list
      }else{
        var list=this.listf
      }
      
      var imagelist = []
      var image = list[index].image
      for (var i = 0; i < image.length; i++) {
        imagelist.push(image[i])
      }
      if (list[index].cover) {
        var cover = list[index].cover
        imagelist.unshift(cover)
      }
      ImagePreview({
        images: imagelist,
        startPosition: 0,
        onClose() {
          this.$appService.isTabbar({state: false})
        },
      });
    },
    onLoad() {
      this.params.user_id = this.user ? this.user.id : 0
      this.params.source = this.source

        // 异步更新数据
        if(this.type==1){
          setTimeout(() => {
            list.getList(this.params).then(res => {
              this.list.push.apply(this.list, res.data.data.data)
              this.params.page += 1
              this.total = res.data.data.total
              this.loading = false
              if(res.data.data.data.length == 0) {
                this.finished = true
              }
            })
          }, 500);
        }else if(this.type==0){
          this.paramsflist.user_id = this.user ? this.user.id : 0
          this.paramsflist.source = this.source
          setTimeout(() => {
            list.getList(this.paramsflist).then(res => {
              this.listf.push.apply(this.listf, res.data.data.data)
              this.paramsflist.page += 1
              this.totalf = res.data.data.total
              this.loading = false
              this.update_num= res.data.data.update_num
              if(res.data.data.data.length == 0) {
                this.finished = true
              }
              if (res.data.data.update_num > 0) {
                setTimeout(function () {
                  that.setData({
                    shou_update_num: false
                  })
                }, 4000)
              }
            })
          //  member.getSpaceList(this.paramsf).then(res => {
          //   this.listf.push.apply(this.listf, res.data.data.data)
          //   this.paramsf.page += 1
          //   this.total = res.data.data.total
          //   this.loading = false
          //   if(res.data.data.data.length == 0) {
          //     this.finished = true
          //   }
          // })
        }, 500);
        }else if(this.type==2){
          setTimeout(() => {
            content.getTopicList(this.paramst).then(res => {
              if(res.data.state == 1) {
                this.paramst.page += 1
                this.total = res.data.data.total
                this.loading = false
                if(res.data.data.data.length == 0) {
                  this.finished = true
                }
                this.oldlist.push.apply(this.oldlist, res.data.data.data)
                let list=this.oldlist;
                let topiclist=[];
                let arr=[]
                for(var i=0;i<list.length;i++){
                 let year= list[i].create_year
                 let mon= list[i].create_en_month
                 let ym=year+'-'+mon
                 list[i].ym=ym
               }
               for(var i=0;i<list.length;i++){
                if(i>0){
                  if(list[i].ym==list[i-1].ym){
                    list[i].show=false
                  }else{
                    list[i].show=true
                  }
                }else{
                  list[i].show=true
                }
              }
              this.listT= list
            }
          })
          }, 500);
        }       
      },
    },
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tag.name]: Tag,
      [Button.name]: Button,
      [Popup.name]:Popup,
      [Cell.name]:Cell,
      [CellGroup.name]:CellGroup,
      [Icon.name]:Icon,
      [ActionSheet.name]:ActionSheet,
      [Divider.name]:Divider,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [PullRefresh.name]:PullRefresh,
      [Field.name]:Field,
      [Overlay.name]:Overlay,
      [NavBar.name]:NavBar,
      [ImagePreview.name]:ImagePreview,
      [NoticeBar.name]:NoticeBar,
      [Sticky.name]:Sticky
    }
  }
</script>
<style lang="scss">
.home{
  padding-bottom: 60px;
  .top_box{
    width: 100%;
    height: 48px;
    color: #fff;
    font-size: 14px;
    background-color: #605C6B;
    justify-content: center;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 1000;
    // top: 50px;
    .title_pic{
     width: 73px;
     height: 36px;
     margin: 0 8px;
   }
 }
 a {
  padding: 0;
  color: #3A3A3A;
}
.bbsrem{
  margin-top: 100px;
}
.van-nav-bar{
  z-index: 999;
  position: fixed;
  top: 0;
  width: 100%;
  height: auto;
  .van-nav-bar__left{
    top: 10px;
    .homemem{
      width:30px;
      height:30px;
      object-fit: cover;
    }
  }
  .van-nav-bar__title{
    .navbartitle{
      margin-top: 10px;
      width: 30px;
      height: 27px;
    }
  }
  .font-color{
    color: #b0b0b0;
  }
    // .van-nav-bar__title{
    //   line-height: 1.8;
    //   height: 50px;
    // }
    .van-nav-bar__right{
      top: 5px;
      .homewrite{
        width: 20px;
      }
    }
  }
  .topic{
    .topichei{
      height: 240px;
    }
    .topicpic{
      width: 100%;
      height: 240px;
      object-fit: cover;
    }
    .picount{
      color: #fff;
      margin-top: -35%;
      padding: 10px;
      position: absolute;
      .mt-10{
        margin-top: 10px;
      }
      .van-divider{
        width: 105px;
        border-color: #fff;
      }
    }
    .topcheight{
      padding: 16px;
    }
  }
  .van-swipe__indicator{
    width: 15px;
    height: 3px;
    border-radius:1px;
  }
  .swipe-img{
    width: 100%;
    height: 225px;
    display: block;
    object-fit: cover;
  }
  .swiped-img{
    width: 100%;
    height: 225px;
    position: fixed;
    top: 0;
    display: block;
    object-fit: cover;
  }
  .addtopicbox{
    min-height: 175px;
    margin-top: 15px;
    border-bottom: 1px solid #EEEEEE;
    .indextopicbox {
      color: #718EC4;
      background-color: #F3F8FF;
      font-size: 12px !important;
      width: auto !important;
      min-width: 25px;
      max-width: 250px;
      font-weight: 400;
      border: none;
      padding: 2px 6px !important;
      margin: 5px 15px;
      text-align: center;
    }
    .changeTopic{
      text-align: center;
      margin-top: 15px;
      font-size: 12px;
      color: #999999;
      .changeimg{
        width: 16px;
        height: 13px;
        vertical-align: middle;
        margin-right: 5px;

      }
    }
  }
  .handbox {
    position: fixed;
    top: 0;
    z-index: 999;
    padding: 8px 16px;
    width: 100%;
    box-sizing: border-box;
    height: 50px;
    .homemem{
      width:30px;
      height:30px;
      float: left;
      margin-top: 2px;
      object-fit: cover;
    }
    .font-color{
      color: #b0b0b0;
    }
    .font-wright{
      color: #fff;
    }
    .font-black{
      color: #3a3a3a;
    }
    .homewrite{
      width: 20px;
      height: 20px;
      float:right;
      display: block;
      margin-top: 5px;
      vertical-align: middle;
    }
  }

  .box{
    border-bottom: 1px solid #EAEAEA;

    .list-box {
      padding: 15px 10px;
      a {
        padding: 0;
        color: #3A3A3A;
      }
      .listitle{
        font-size: 15px;
        font-weight:bold;
        line-height: 22px;
        letter-spacing: 1.4px;
        margin-top: 12px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
        vertical-align: middle;
      }
      .statenum{
        font-size: 13px;
        color: #605C6B;
          // font-weight: bold;
          vertical-align: middle;
        }
        .binpic{
          width:15px;
          height:15px;
          margin-right:8px;
          vertical-align: middle;
        }
        .writecomm{
          width:10px;
          height:10px;
          margin-right:8px;
          vertical-align: middle;
        }
        .binbox{
          margin-right:20px;
          .location{
            width:12px;
            height:15px;
            margin-right:8px;
            vertical-align: middle;
          }
        }
        .ml-10{
          margin-left: 10px;
        }
        .bintright{
          text-align:right;
          .active{
            font-size: 12px;
            line-height: 2;
            vertical-align: super;
          }
          .settop{
            border: 1px solid #9a9a9a;
          }
          .van-button--small{
            height: 24px;
            padding: 0 8px;
            line-height: 20px;
            border-radius: 1px;
            vertical-align: middle;
          }
          .ml-5{
            margin-left: 5px;
          }

          .van-button__icon{
            font-size: 10px;
          }
          .van-button__text{
            font-size: 11px;
          }
        }
        .listhand{
          width:40px;
          height:40px;
          border-radius: 1.5px;
          display: block;
        }
        .listhand_box{
          width:40px;
          height:40px;
          position:relative;
        }
        .listhand_border{
          width:40px;
          height:40px;
          position:absolute;
          top: 0;
        }
        .comm-discenter{
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          display: flex;
        }
        .handpeop{
          line-height: 0;
        }
        .commhand{
          width:25px;
          height:25px;
          border-radius: 1.5px;
        }
        .opactypic{
          opacity: 0.5;
        }
        .membername{
          font-size: 14px;
          font-weight: bold;
          color: #605C6B;
        }
        .activename{
          font-size: 14px;
          font-weight: bold;
          line-height: 3;
          color: #605C6B;
        }
        .van-tag{
          padding: 2px 10px;
          font-size: 12px;
          margin-right: 5px;
        }
        .quespic{
          width: 22px;
          height: 22px;
        }
        .van-grid-item__content{
          padding: 2.5px;
        }
        .ml-16{
          margin-left: 16px;
        }
        .mt-10{
          margin-top: 10px;
        }
        .mt-15{
          margin-top: 15px;
        }
        .mt-20{
          margin-top: 20px;
        }
        .addcommont{
          line-height: 2;
          .van-cell{
            padding: 0;
            .van-cell__value{
              font-size: 12px;
            }
          }
          .van-icon__image{
            width:10px;
            height:15px;
          }
          .van-button--small{
            z-index: 999;
            height: 24px;
            padding: 0 8px;
            line-height: 20px;
            border-radius: 1px;
            vertical-align: middle;
          }
        }
        .commember{
          /*line-height: 2.2;*/
        }
        .listcontent{
          line-height: 23px;
          margin-top: 12px;
        }
      }
      .list-comm{
        padding: 5px 10px 15px 10px;
      }
    }
    .focus{
      border-bottom: none;
      background-color:#f1f1f1;
      // padding-top:10px;
      .focusrow{
        padding: 10px 0;
      }
      
      .focusbbox{
        position: relative;
        background-color: #fff;
      }
      .changeone{
        text-align: center;
        .van-button{
          margin-top: 40px;
          font-size: 13px;
          line-height: 1;
          width: 120px;
          height: 35px;
          background: #F2F6FA;
        }
      }
    }
    .dvapprove{
      display: flex;
      display: -webkit-box;
      overflow: scroll;
      padding-top: 10px;
      background-color:#f1f1f1;
    }
    .swipe-box{
      width: 150px;
      height: 200px;
      padding: 15px;
      background: #fff;
      margin-left: 10px;
      margin-bottom: 10px;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);
      .border_box{
        width: 50px;
        height: 50px;
        position:relative;
      }
      .border_pic{
        width: 50px;
        height: 50px;
        position:absolute;
        left: 0;
      }
      .c-intro {
        color: #6a6a6a;
      }
      .focuspic{
        width: 50px;
        height: 50px;
        border-radius: 1.5px;
      }
      .mt-5{
        margin-top: 5px;
      }
      .van-button{
        margin-top: 5px;
      }

    }
    .videobox{
      position: relative;
    }
    .videos{
      width: 26px;
      height: 26px;
      position: absolute;
      left: 47%;
      top: 45%;
    }
    .pic-box {
      margin-top: 5px;
      .pic_thumb {
        width: 100%;
        height: 270px;
        object-fit: cover;
        display: block;
      }
      .piclength{
        width: 30px;
        float: right;
        margin-right: 10px;
        margin-top: -25px;
        position: relative;
        font-size: 10px;
        color: #fff;
        background-color: #000000;
        opacity: 0.5;
        text-align: center;
      }
      .picenter{
        width: 25px;
        height: 25px;
        float: right;
        margin-right: 10px;
        margin-top: -35px;
        position: relative;
      }
    }
    .van-popup{
      .van-cell{
        background-color: #5F5B6B;
        color: #fff;
      }
      .popback{
        background-color: #5F5B6B;
        margin-top: 10px;
        .van-cell:not(:last-child)::after{
          right: 10px;
        }
      }
      .triangle{
        width:0;
        height:0;
        border-right:10px solid transparent;
        border-left:10px solid transparent;
        border-bottom:10px solid #5F5B6B;
        float: right;
        margin-right: 5px;
      }
      .van-action-sheet__cancel::before{
        height: 1px;
      }
      .divider{
        margin: 20px 80px;
      }
      .van-grid{
        padding: 10px 0;
      }
    }
    .follow{
      vertical-align: super;
    }
    .followd{
      color: #728FC4;
      background: #F3F9FF;
      border-color: #F3F9FF;
    }
  } 
  .agree{
    width: 100%;
    height: 45px;
    color: #fff;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: #605C6B;
  }
  .disagree{
    width: 100%;
    height: 45px;
    color: #605C6B;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: #fff;
    border:1px solid #605C6B;
  }
  ::-webkit-scrollbar {
    /*隐藏滚轮*/
    display: none;
  }
  .allTopicBox{
    display: flex;
    display: -webkit-box;
    overflow: scroll;
    margin-bottom: 10px;
    padding-top: 10px;
    border-top:1px solid rgba(0, 0, 0, 0.1);
    .alltopic_img{
      width: 150px;
      height: 100px;
      background-size: 150px 100px !important;
      background: #fff;
      margin-right: 10px;
      .alltopic_namebox{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #fff;
        background-color: #000;
        opacity: 0.5;
        white-space: normal;
        .alltopic_name{
          padding: 0 9px;
          height: 33px;
          margin-top: 9px;
        }
      }
    }
  }
  .scroll_title{
    font-size: 12px;
    margin-right: 15px;
  }
  .tuijian {
    margin: 0 110px;
    padding: 5px 8px;
    text-align: center;
    font-size: 12px;
    color: #605C6B;
    margin-bottom: 10px;
    background-color: #ffffff;
  }
  .van_swipeo{
    width: 190px !important;
  }
</style>